import { Box, Container, Typography } from '@mui/material'
import { AutoFixHigh } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { designSpecs } from '../../theme/designSpecs'

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        borderTop: '1px solid',
        borderColor: 'grey.200',
        bgcolor: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* Logo and Copyright */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                background: designSpecs.gradients.primary,
                borderRadius: designSpecs.borderRadius.lg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 3,
              }}
            >
              <AutoFixHigh sx={{ color: 'white', fontSize: designSpecs.iconSizes.md }} />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  background: designSpecs.gradients.primary,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  fontSize: designSpecs.typography.sizes.lg,
                }}
              >
                Mocksy
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: 'grey.500',
                  fontSize: designSpecs.typography.sizes.xs,
                }}
              >
                © 2025 All rights reserved
              </Typography>
            </Box>
          </Box>

          {/* Links */}
          <Box
            sx={{
              display: 'flex',
              gap: 4,
            }}
          >
            <Typography
              component={Link}
              to="/policy"
              sx={{
                fontSize: designSpecs.typography.sizes.sm,
                color: 'grey.600',
                textDecoration: 'none',
                fontWeight: 500,
                transition: designSpecs.transitions.default,
                '&:hover': {
                  color: 'primary.main',
                },
              }}
            >
              Privacy Policy
            </Typography>
            <Typography
              component={Link}
              to="/terms"
              sx={{
                fontSize: designSpecs.typography.sizes.sm,
                color: 'grey.600',
                textDecoration: 'none',
                fontWeight: 500,
                transition: designSpecs.transitions.default,
                '&:hover': {
                  color: 'primary.main',
                },
              }}
            >
              Terms of Service
            </Typography>
            <Typography
              component={Link}
              to="#"
              sx={{
                fontSize: designSpecs.typography.sizes.sm,
                color: 'grey.600',
                textDecoration: 'none',
                fontWeight: 500,
                transition: designSpecs.transitions.default,
                '&:hover': {
                  color: 'primary.main',
                },
              }}
            >
              Contact
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
